import React from 'react';
import ScrollbarSvg from '../scrollbar/ScrollbarSvg';
import { gridBorder } from './styles';

const ScrollbarCell = ({
    scrollPxV,
    scrollPxH,
    onScroll,
    style,
    maxVisibleRows = 0,
    maxVisibleLength,
    scrollableLength,
    gutterOffset,
    onSizeChange,
    highlightedIdx,
    ...props
}) => {
    return (
        <td
            {...props}
            id='scrollbar-cell'
            style={{
                ...gridBorder,
                boxSizing: 'border-box',
                width: 16,
                verticalAlign: 'top',
                backgroundColor: 'white',
                right: scrollPxH
            }}
            rowSpan={maxVisibleRows}
        >
            <ScrollbarSvg
                scrollPx={scrollPxV}
                onScroll={onScroll}
                maxVisibleLength={maxVisibleLength}
                scrollableLength={scrollableLength}
                gutterOffset={gutterOffset}
                onSizeChange={onSizeChange}
            />
        </td>
    );
};

export default ScrollbarCell;
